import { Popover } from '@base-ui/react/popover';
import type { ReactNode } from 'react';
import { cx } from '@/cva.config';

interface StatusPopoverProps {
  children: ReactNode;
  onOpenChange: (open: boolean) => void;
  open: boolean;
  trigger: ReactNode;
}

export const StatusPopover = ({
  children,
  onOpenChange,
  open,
  trigger,
}: StatusPopoverProps) => (
  <Popover.Root onOpenChange={onOpenChange} open={open}>
    <Popover.Trigger>{trigger}</Popover.Trigger>
    <Popover.Portal>
      <Popover.Positioner align="start" side="top" sideOffset={8}>
        <Popover.Popup
          className={cx(
            'z-70 min-w-65 rounded-md border border-border-active bg-surface px-3 py-3 font-mono text-2xs lg:text-xs text-foreground-muted shadow-xl',
            'transition-opacity duration-180 data-ending-style:opacity-0 data-starting-style:opacity-0',
          )}
        >
          {children}
        </Popover.Popup>
      </Popover.Positioner>
    </Popover.Portal>
  </Popover.Root>
);
